import { makeApiRequest } from '@/src/lib/api-request'
import { useMutation } from '@tanstack/react-query'
 
export const useCreateStripeOnboardingAccountMutation = () => {
  return useMutation({
    mutationKey: [ 'stripeOnboardAccount'],
    mutationFn: async (params: {email:string,country:string}) => {return await makeApiRequest({
        url: `/Stripe_Payout/stripeCreateAccount`,
        method: 'POST',
        data: {
          ...params,
        },
        isAuthenticated: true,
        fallbackError: 'noFallback',
        isV3Api: true,
      })
    },
    onSuccess(data) {
      return data
    },
  })
}
export const useUpdateStripeOnboardingAccountMutation = () => {
  return useMutation({
    mutationKey: ['stripeUpdateOnboardAccount'],
    mutationFn: async (params: {StripeAccountId?:string,isOnboard?:string}) => {return await makeApiRequest({
        url: `/Stripe_Payout/stripeAccountOnboard`,
        method: 'POST',
        data: {
          ...params,
        },
        isAuthenticated: true,
        fallbackError: 'noFallback',
        isV3Api: true,
      })
    },
    onSuccess(data) {
      return data
    },
  })
}
export const useGetStripeOnboardingAccountDataMutation = () => {
  return useMutation({
    mutationKey: ['user', 'stripeAccountDetails'],
    mutationFn: async (params: {StripeAccountId:string}) => {return await makeApiRequest({
        url: `/Stripe_Payout/stripeAccountDetails`,
        method: 'POST',
        data: {
          ...params,
        },
        isAuthenticated: true,
        fallbackError: 'noFallback',
        isV3Api: true,
      })
    },
    onSuccess(data) {
      return data
    },
  })
}
